export const CASINO_COIN_WAY = "coin";
export const CASINO_FREE_WAY = "free";
export const CASINO_EXTRA_WAY = "extra";
export const CASINO_DOUBLE_WAY = "double";

export const CASINO_GAME_SPIN = "spin";
export const CASINO_GAME_SLOTS = "slots";
export const CASINO_GAME_DICE = "sic_bo";
